import React from "react"

import { Helmet } from "react-helmet"

interface IAuto {
  titleH1?: string
  description?: string
  shortTitle?: string
  url?: string
}

export const Auto = ({ titleH1, description, shortTitle, url }: IAuto) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify([
        {
          "@context": "https://schema.org",
          "@type": "BankOrCreditUnion",
          name: "Совкомбанк",
          image: "https://sovcombank.ru/logo.png",
          "@id": "https://sovcombank.ru/",
          url: "https://sovcombank.ru/",
          telephone: "8 (800) 200 66-96",
          priceRange: "150 000 - 5 000 000",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Краснопресненская набережная, 14 стр 1",
            addressLocality: "Москва",
            postalCode: "123100",
            addressRegion: "Московская область",
            addressCountry: "RU",
          },
          openingHoursSpecification: {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday",
            ],
            opens: "00:00",
            closes: "23:59",
          },
          sameAs: [
            "https://ru.wikipedia.org/wiki/Совкомбанк",
            "https://sovcombank.ru/",
            "https://www.youtube.com/channel/UCptG0e45r5jZexlXJ_obmvA",
          ],
        },
      ])}
    </script>
    <script type="application/ld+json">
      {JSON.stringify([
        {
          "@context": "https://schema.org/",
          "@type": "Product",
          name: `${titleH1}`,
          image: "https://sovcombank.ru/logo.png",
          description: `${description}`,
          brand: {
            "@type": "Brand",
            name: "Совкомбанк",
          },

          offers: {
            "@type": "AggregateOffer",
            url: `${url}`,
            priceCurrency: "RUB",
            highPrice: "5000000",
            lowPrice: "150000",
            availability: "https://schema.org/InStock",
          },

          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "4,9",
            bestRating: "5",
            worstRating: "1",
            ratingCount: "10641",
          },
        },
        {
          "@context": "https://schema.org/",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Совкомбанк",
              item: "https://sovcombank.ru/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "🔒Кредиты",
              item: "https://sovcombank.ru/credits",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "🔒Кредиты под залог",
              item: "https://sovcombank.ru/credits/pod-zalog",
            },

            {
              "@type": "ListItem",
              position: 4,
              name: `${shortTitle}`,
              item: `${url}`,
            },
          ],
        },
        {
          "@context": "https://schema.org",
          "@type": "Corporation",
          name: "Совкомбанк",
          alternateName: "Sovcombank",
          url: "https://sovcombank.ru/",
          logo: "https://sovcombank.ru/logo.png",
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "8 (800) 200-66-96",
            contactType: "customer service",
            contactOption: "TollFree",
            areaServed: "RU",
            availableLanguage: "Russian",
          },
        },
      ])}
    </script>
  </Helmet>
)
